export default function convertSVGinline(selector = '.inline-svg') {
	const svgImages = document.querySelectorAll(`img${selector}`);

	if (!svgImages.length) return;

	svgImages.forEach(async (img) => {
		try {
			const imgID = img.id;
			const imgClass = img.className;
			const imgURL = img.src;

			if (!imgURL.endsWith('.svg')) {
				console.error('Invalid SVG URL:', imgURL);
				return;
			}

			const response = await fetch(imgURL, { mode: 'cors' });
			if (!response.ok) {
				throw new Error(
					`Network response was not ok: ${response.statusText}`
				);
			}

			const data = await response.text();
			const parser = new DOMParser();
			const xmlDoc = parser.parseFromString(data, 'image/svg+xml');
			const svg = xmlDoc.querySelector('svg');

			if (!svg) {
				throw new Error('No SVG element found in the fetched data');
			}

			if (imgID) {
				svg.setAttribute('id', imgID);
			}

			if (imgClass) {
				svg.setAttribute('class', `${imgClass} replaced-svg`);
			}

			svg.removeAttribute('xmlns:a');
			svg.removeAttribute('script'); // Remove potentially harmful script elements

			img.parentNode.replaceChild(svg, img);
		} catch (error) {
			console.error('Error fetching or processing SVG:', error);
		}
	});
}
